<template>
    <b-card no-body>
        <template #header>
            <b-button size="sm" variant="outline-secondary" class="me-2" @click="$router.back()">
                <i class="fas fa-arrow-left"></i>
            </b-button>
            <strong>
                Revisions
            </strong>
        </template>
        <div v-show="revisions.length > 0" id="revisions-bar" class="revisions-bar ps-1 pe-1" >
            <span class="roundIcon" :id="`revision-${index}`" :class="getRevisionTypeColour(revision)" style="font-size: 1.8rem;" v-for="(revision, index) in revisions" @click="$emit('selectRevision',index)" :key="index"  > <!-- v-b-tooltip.hover.v-primary :title="getTooltipInfo(revision)"    :title="revision.published == 1 ? 'Published' : 'Draft'"-->
                <span v-if="index != 0">-</span>
                <i class="fas" :class="getIconType(revision, index)"></i>
                <!-- <i v-if="selectedRevisionIndex == index" class="fas fa-check-circle"></i>
                <i v-else class="fas fa-circle"></i> -->
                <!-- v-if="index == selected_revision_index" -->
            </span>
            <div v-if="hasSops">
                <b-alert class="m-0" :show="true">
                    No Revision History
                </b-alert>
            </div>
        </div>
        <b-alert class="m-0" :show="revisions.length == 0">
            No revisions have been created yet
        </b-alert>
    </b-card>
</template>

<script>
export default {
    props:{
        hasSops:{
            default: false,
        },
        revisions:{
            default: [],
        },
        selectedRevisionIndex:{
            default: -1,
        }

    },
    data:() => ({
        
    }),
    watch:{
        selectedRevisionIndex(newVal){
            if(this.revisions.length == 0){
                return;
            }
            setTimeout(()=>{
                //document.getElementById(`revision-${newVal}`).scrollIntoView();
                var itemId = `revision-${newVal}`;
                var container = document.getElementById('revisions-bar');
                var targetItem = document.getElementById(itemId);

                var containerRect = container.getBoundingClientRect();
                var itemRect = targetItem.getBoundingClientRect();

                //var containerWidth = containerRect.width;
                var itemRight = itemRect.right; // Get the absolute right position of the item

                // Calculate the amount needed to scroll for the item to be fully visible
                var scrollAmount = itemRight - containerRect.right + 40;

                // Scroll the container by the calculated amount
                container.scrollLeft += scrollAmount;
            })
        }
    },
    computed:{},
    methods:{
        getTooltipInfo(doc_revision){
            console.log(doc_revision)
            return {
                customClass: 'evision-popover-class',
                placement: 'bottom',
                title: 'Cumulative Data',
                content: `Cumulative data represents the accumulation of data over a certain period of time. It is the sum or total of all the individual data points up to a particular point in time. For example, if you are tracking the total revenue earned over a month, the data for each day would be cumulative, as it represents the accumulation of revenue up to that day. Cumulative data is typically represented as a running total on a graph or chart, and progress is measured based on the overall trend of the accumulated values over time. For instance, you may track the total revenue generated over a month, with each day's value added to the cumulative total.`
            }
        },
        getIconType(doc_revision, revision_index){
            if(this.selectedRevisionIndex == revision_index){
                return 'fa-check-circle fa-fw';
            }

            if(doc_revision.created_by_builder){
                return 'fa-file-alt fa-fw'
            }
            else if(!doc_revision.created_by_builder){
                return 'fa-file-pdf fa-fw'
            }
            return 'fa-circle'
        },
        getRevisionTypeColour(doc_revision){
            if(doc_revision.published == 1){
                return 'published_icon';
            }
            else if(doc_revision.created_by_builder){
                return 'builder_icon';
            }
            else if(!doc_revision.created_by_builder){
                return 'pdf_icon'
            }
            else if(doc_revision.active == 1){
                return 'active_icon'
            
            }
            else{
                return 'default_icon'
            }
        }
    },
    mounted(){},
}
</script>

<style>
.revision-popover-class{
    margin-top: 25px;
}
.pdf_icon{
    color: #ff7878;
}
.published_icon{
    color: #05B15F;
}
.builder_icon{
    color: #558ef8;
}
.active_icon{
    color: #09bade;
}
.default_icon{
    color: orange;
}

</style>